module.exports = __webpack_public_path__ + "static/media/fox2_thumb.90c62038.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/projects/fox2_thumb.png
// module id = 179
// module chunks = 0